const initHeroProgress = () => {
    const heroElements = document.querySelectorAll('.swiper-hero');

    heroElements.forEach(element => {
        const activeSlide = element.querySelector('.swiper-slide-active') || element.querySelector('.swiper-slide');
        const progressBars = activeSlide?.querySelectorAll('.hero-progress-bar') || [];

        if (progressBars.length === 0) return;

        const swiper = element.swiper;
        if (!swiper) {
            return;
        }

        const autoplayDelay = swiper.params.autoplay?.delay || 3000;
        let currentActiveIndex = swiper.realIndex;

        const getCurrentProgressBars = () => {
            const currentSlide = element.querySelector('.swiper-slide-active');
            return currentSlide?.querySelectorAll('.hero-progress-bar') || [];
        };

        const startProgress = (activeIndex) => {
            const currentBars = getCurrentProgressBars();

            currentBars.forEach((bar, index) => {
                const fill = bar.querySelector('.hero-progress-fill');
                if (fill) {
                    fill.style.width = '0%';
                    fill.style.transition = 'none';
                }

                if (index === activeIndex) {
                    bar.classList.add('is-active');
                } else {
                    bar.classList.remove('is-active');
                }
            });

            const activeFill = currentBars[activeIndex]?.querySelector('.hero-progress-fill');
            if (activeFill) {
                setTimeout(() => {
                    activeFill.style.transition = `width ${autoplayDelay}ms linear`;
                    activeFill.style.width = '100%';
                }, 50);
            }
        };

        const attachClickHandlers = () => {
            const currentBars = getCurrentProgressBars();
            currentBars.forEach((bar, index) => {
                bar.addEventListener('click', () => {
                    swiper.slideToLoop(index);
                });
            });
        };

        swiper.on('slideChange', () => {
            const activeIndex = swiper.realIndex;
            if (activeIndex !== currentActiveIndex) {
                currentActiveIndex = activeIndex;
                setTimeout(() => {
                    attachClickHandlers();
                    startProgress(activeIndex);
                }, 10);
            }
        });

        swiper.on('autoplayStart', () => {
            startProgress(swiper.realIndex);
        });

        swiper.on('autoplayStop', () => {
            const currentBars = getCurrentProgressBars();
            currentBars.forEach((bar) => {
                const fill = bar.querySelector('.hero-progress-fill');
                if (fill) {
                    fill.style.transition = 'none';
                }
            });
        });

        attachClickHandlers();
        if (swiper.autoplay?.running) {
            startProgress(swiper.realIndex);
        }
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroProgress);
} else {
    initHeroProgress();
}
